<div *ngIf="init && inputList != null && inputBoard.id != null">
  <div class="title">Prijzen per deelbord</div>
  <mat-card class="mat-elevation-z0" style="margin-left: 5px;">
    <div *ngFor="let part of inputBoard.boardParts; let index = index">
      <div *ngIf="part.id != null">
        <div class="title">Bord #{{ index + 1 }}</div>
        <price-line-input
          [priceLine]="boardPartToProductionPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          [priceLine]="boardPartToConstructionPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          [priceLine]="boardPartToPlacementPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          *ngIf="part.distanceToBottom == null"
          [priceLine]="boardPartToDistanceToBottomPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          [priceLine]="boardPartToTransportPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          *ngIf="part.paintedPosts"
          [priceLine]="boardPartToPaintedPostsPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
        <price-line-input
          [priceLine]="boardPartToRepoPrice.get(part.id)"
          (output)="doUpdate()"
        ></price-line-input>
      </div>
    </div>
  </mat-card>
  <div class="title upper-space">Overkoepelende prijzen</div>
  <mat-card class="mat-elevation-z0 under-space" style="margin-left: 5px;">
    <price-line-picker
      [inputList]="otherPrices"
      [inputProduct]="inputBoard"
      [alignWithBoardPrices]="true"
      (output)="doUpdate()"
    ></price-line-picker>
  </mat-card>
</div>
